import { Box, Button } from '@mui/material';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectTeamMembers, selectTeamMembersHash } from 'selectors';
import Modal from 'shared/Modal';
import { updateTeamMember } from 'thunk';
import { isSuperAdmin } from 'utils';
import { CustomFieldsContainer } from './TeamMembersTable/style';
import { useNotification } from 'hooks/useNotification';

export const PromoteSuperAdminModal: FC<{
  onClose: VoidFunction;
  accountId: number;
}> = ({ onClose, accountId }) => {
  const { isUpdatingMember } = useSelector(selectTeamMembers);
  const memberHash = useSelector(selectTeamMembersHash);
  const member = memberHash[accountId];
  const dispatch = useDispatch();
  const { showSuccess } = useNotification();

  // `memberHash` only holds the current page (GLX-1740); if this member isn't
  // resolvable, render nothing rather than crashing on member.* access.
  if (!member) {
    return null;
  }

  const promoteUserToSuperAdmin = () => {
    // TODO: Fix with Redux Toolkit configureStore migration
    dispatch(
      updateTeamMember({
        teamMembershipId: member.team_membership_id,
        team_role: 100,
        onSuccess: ({ response }) => {
          if (isSuperAdmin(response.data.team_member.role_ids)) {
            showSuccess('Successfully promoted member to super admin.');
            onClose();
          }
        },
      }) as any,
    );
  };

  return (
    <Modal open onClose={onClose}>
      <CustomFieldsContainer>
        <h2>Promote</h2>
        <p>
          Press &quot;Promote&quot; to promote <u>{member?.name || 'this user'} </u>to a super
          admin. <strong>This action should only be done with Team leads&apos; permission.</strong>
        </p>
        <br />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
          }}
        >
          <Button color="primary" disabled={isUpdatingMember} onClick={promoteUserToSuperAdmin}>
            Promote
          </Button>
        </Box>
      </CustomFieldsContainer>
    </Modal>
  );
};
